import { render, staticRenderFns } from "./AddApplicationTemplate.vue?vue&type=template&id=248cd9b8&scoped=true"
import script from "./AddApplicationTemplate.vue?vue&type=script&lang=ts"
export * from "./AddApplicationTemplate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248cd9b8",
  null
  
)

export default component.exports